export const TITLE =
  "¡Fuiste registrado con éxito!\nAguardá a que el administrador active tu cuenta.";
